import { useEffect, useState } from "react";

const navLinks = [
  { href: "#hot", label: "最新热点" },
  { href: "#categories", label: "主题栏目" },
  { href: "#featured", label: "本期高光" },
  { href: "#collections", label: "红料合集" },
  { href: "#people", label: "人物特写" },
  { href: "#about", label: "关于本站" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* 顶部滚动红料条 */}
      <div className="relative z-30 bg-primary-600 text-background-50">
        <div className="overflow-hidden py-2">
          <div className="animate-marquee flex w-max whitespace-nowrap text-xs md:text-sm tracking-wide">
            {[0, 1].map((n) => (
              <span key={n} className="flex items-center px-6">
                <i className="ri-heart-3-fill mr-2 text-accent-300" />
                今日正能量 · 公交司机背老人趟水获点赞
                <i className="ri-sparkling-2-fill mx-4 text-accent-300" />
                快递驿站站长让小店成为街坊便民点
                <i className="ri-heart-3-fill mr-2 text-accent-300" />
                大学生志愿者为山村老人拍下合影
                <i className="ri-sparkling-2-fill mx-4 text-accent-300" />
                医生休年假途中出手救人，全程不到一分钟
              </span>
            ))}
          </div>
        </div>
      </div>

      <header
        className={`sticky top-0 z-40 transition-all duration-300 ${
          scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
        }`}
      >
        <nav className="relative z-20 flex h-16 items-center justify-between px-4 md:px-6" aria-label="主导航">
          <a href="#top" className={`flex items-center gap-2 whitespace-nowrap ${scrolled ? "" : "text-background-50"}`}>
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-community-fill text-lg" />
            </span>
            <span className={`font-heading text-xl md:text-2xl font-bold leading-none ${scrolled ? "text-foreground-950" : "text-background-50"}`}>
              红黑料
              <span className="ml-2 hidden md:inline-block align-middle rounded-full px-2 py-0.5 text-[10px] font-medium tracking-wider text-background-50 bg-primary-500">正面爆料</span>
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors cursor-pointer ${
                  scrolled
                    ? "text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
                    : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
                }`}
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="hidden lg:flex items-center">
            <a
              href="#contact"
              className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-quill-pen-line mr-1.5 align-[-1px]" />
              我要投稿
            </a>
          </div>

          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            onClick={() => setOpen((v) => !v)}
            className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-transparent lg:hidden ${
              scrolled ? "text-foreground-950 border-background-200" : "text-background-50 border-background-50/30"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </nav>

        {/* 移动端下拉面板 */}
        <div
          className={`overflow-hidden transition-[max-height] duration-300 lg:hidden ${
            open ? "max-h-96 border-t border-background-200 bg-background-50" : "max-h-0"
          }`}
        >
          <div className="flex flex-col px-4 py-3 md:px-6">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-sm text-foreground-800 hover:bg-primary-100 hover:text-primary-700 cursor-pointer"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-center text-sm font-medium text-background-50 hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-quill-pen-line mr-1.5 align-[-1px]" />
              我要投稿
            </a>
          </div>
        </div>
      </header>
    </>
  );
}